import { parseAkamaiHeader } from './parseAkamaiHeader.js';

/* eslint-disable no-console */
function handleAkamaiDevice({
  req
}) {
  if (req) {
    const akamaiDeviceHeader = req.header('x-akamai-device-characteristics');
    if (akamaiDeviceHeader) {
      // ensure akamai property on the request
      if (!req.akamai) {
        req.akamai = {};
      }
      req.akamai.device = parseAkamaiHeader(akamaiDeviceHeader, {
        delimiter: ';'
      });
    }
  }
}
function expressAkamaiDeviceMiddleware(req, res, next) {
  handleAkamaiDevice({
    req
  });
  next();
}
function withCtxAkamaiDevice() {
  return ctx => {
    if (ctx.req) {
      handleAkamaiDevice(ctx);
    }
  };
}

export { expressAkamaiDeviceMiddleware, handleAkamaiDevice, withCtxAkamaiDevice };
